__turbopack_context__.v({
  "container": "style-module-scss-module__4xgzeG__container",
  "fullWidth": "style-module-scss-module__4xgzeG__fullWidth",
  "mainContent": "style-module-scss-module__4xgzeG__mainContent",
  "sidebar": "style-module-scss-module__4xgzeG__sidebar",
  "sidebarOverlap": "style-module-scss-module__4xgzeG__sidebarOverlap",
  "sidebarSticky": "style-module-scss-module__4xgzeG__sidebarSticky",
  "topContent": "style-module-scss-module__4xgzeG__topContent",
  "topContentSticky": "style-module-scss-module__4xgzeG__topContentSticky",
  "twoColumnRow": "style-module-scss-module__4xgzeG__twoColumnRow",
  "twoColumnRowOverlap": "style-module-scss-module__4xgzeG__twoColumnRowOverlap",
});
